import commonJsModule from "read-file-json"

export default commonJsModule.default